import { useForm, Controller } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField, Checkbox } from '../../../../../components';
import { RadioGroup, Radio, FormControlLabel, Button, Container, Dialog, Divider, Grid, IconButton, Paper, Stack, Tab, Tabs, Typography, TextField as MuiTextField, Box } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { DischargeSummaryMedicineDetailsForm } from '../../HMS/transactions/DischargeSummaryMedicineDetailsForm';
// import { ComplaintsForm } from './ComplaintsForm';
import { DischargeSummaryAddDiagnosForm } from '../../HMS/transactions/DischargeSummaryAddDiagnosForm';
import { OPDBillingDetailForm } from '../../HMS/transactions/OPDBillingDetailForm';
import { CKEditor } from '@ckeditor/ckeditor5-react';  // Corrected import
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const PATIENT_TABLE_HEADER = [
    { header: 'UHID', accessor: 'uhid' },
    { header: 'OP No', accessor: 'op_no' },
    { header: 'Created At', accessor: 'createdAt' },
    { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name}` },
    { header: 'Mobile No', accessor: 'address.mobile' },
    { header: 'Doctor', accessor: 'consultant.name' },
    { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
    {
        header: ' Date',
        accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
    },
    {
        header: 'UHID No',
        accessor: 'uhid'
    },
    {
        header: 'Patient Name',
        accessor: (row) => {
            const status = row.status;
            return (
                <span
                    style={{
                        color: status === 'inactive' ? 'red' : 'black',
                    }}
                >
                    {`${row?.patient?.name}`}
                </span>
            );
        },
    },
    {
        header: 'Sponsor',
        accessor: 'patient.sponsor'
    },
    {
        header: 'Mobile No',
        accessor: 'patient.mobile_no'
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    }
];


const PAST_VITAL_HISTORY_TABLE_HEADER = [
    {
        header: 'Vitals',
        accessor: (row) => {
            const vitals = [
                row.vital.bp_sys && `Bp Systolic ${row.vital.bp_sys}`,
                row.vital.diastol && `Diastol ${row.vital.diastol}`,
                row.vital.abdomen && `Abdomen ${row.vital.abdomen}`,
                row.vital.pulse && `Pulse ${row.vital.pulse}`,
                row.vital.dm && `DM ${row.vital.dm}`,
                row.vital.asthma && `Asthma ${row.vital.asthma}`,
                row.vital.ihd && `IHD ${row.vital.ihd}`,
                row.vital.con_level && `Con Level ${row.vital.con_level}`,
                row.vital.temp && `Temp ${row.vital.temp}`,
                row.vital.weight && `Weight ${row.vital.weight}`,
                row.vital.resp_rate && `Resp Rate ${row.vital.resp_rate}`,
                row.vital.chest && `Chest ${row.vital.chest}`,
                row.vital.cvs && `CVS ${row.vital.cvs}`,
                row.vital.dre && `Dre ${row.vital.dre}`,
                row.vital.cns && `Cns ${row.vital.cns}`,
                row.vital.any_other && `Any Other ${row.vital.any_other}`,
                row.vital.allergies && `Allergies ${row.vital.allergies}`,
                row.vital.height && `Height ${row.vital.height}`,
                row.vital.blood_group && `Blood Group ${row.vital.blood_group}`,
                row.vital.pallor && `Pallor ${row.vital.pallor}`,
                row.vital.icterus && `Icterus ${row.vital.icterus}`,
                row.vital.clubbing && `Clubbing ${row.vital.clubbing}`,
                row.vital.cyanos && `Cyanos ${row.vital.cyanos}`,
                row.vital.jvp && `JVP ${row.vital.jvp}`,
                row.vital.lymphade && `Lymphade ${row.vital.lymphade}`,
                row.vital.hydration && `Hydration ${row.vital.hydration}`
            ];
            return vitals.filter(Boolean).join(', ');
        },
    },
    {
        header: "Date",
        accessor: "createdAt"
    }
];


const ADD_Surgery = [
    {
        header: 'IPD No.',
        accessor: 'complaints'
    },

    {
        header: 'Patient Name',
        accessor: 'duration'
    },
    {
        header: 'Record By',
        accessor: 'duration'
    },
    {
        header: 'ADM. Date',
        accessor: 'duration'
    },

]

const ADD_Diagnosis = [
    {
        header: 'Particulars',
        accessor: (row) => row.complaints
    },
    {
        header: 'Cost Center',
        accessor: "createdAt"
    },
    {
        header: 'Analysis',
        accessor: "createdAt"
    },
    {
        header: 'Sub Analysis',
        accessor: "createdAt"
    },
    {
        header: 'Dr/Cr',
        accessor: "createdAt"
    },
    {
        header: 'Dr Amt',
        accessor: "createdAt"
    },
    {
        header: 'Cr Amt',
        accessor: "createdAt"
    },
    {
        header: 'Action',
        accessor: "createdAt"
    },
]

const ADD_Resource = [
    {
        header: 'Resource Type',
        accessor: (row) => row.complaints
    },
    {
        header: 'Resource Name',
        accessor: "createdAt"
    },
    {
        header: 'Actions',
        accessor: "createdAt"
    }
]

const DIAGNOSIS_LIST_HEADER = [
    {
        header: "Diagnosis List",
        accessor: "add_diagnos"
    },
    {
        header: "Date",
        accessor: "createdAt"
    }
]


const PAST_HISTORY_DIAGNOS = [
    {
        header: 'Diagnos',
        accessor: (row) => row.add_diagnos
    },
    {
        header: 'Date',
        accessor: "createdAt"
    }

]

const SERVICE_LAB_HEADER = [
    {
        header: "Type",
        accessor: "type"

    },
    {
        header: "Operating Doctor",
        accessor: "doctor"
    },
    {
        header: "Service Name",
        accessor: "service"
    },
    {
        header: "Qty",
        accessor: "quantity"
    },
    {
        header: "Rate",
        accessor: "rate"
    },
    {
        header: "Amount",
        accessor: "amount"
    },
    {
        header: "Dis. Amt.",
        accessor: ""
    },
    {
        header: "Net. Amt.",
        accessor: "net_amt"
    },
    {
        header: "Date",
        accessor: "date"
    }
]

const PAST_SERVICE_LAB_HISTORY_HEADER = [
    {
        header: 'Date',
        accessor: "createdAt",
    },
    {
        header: 'Service',
        accessor: (row) => row.service,
    },
    {
        header: 'Lab Test',
        accessor: "",
    },
]

const MEDICINE_DETAIL_HEADER = [
    {
        header: "Medicine Name",
        accessor: "medicine_name"
    },
    {
        header: "Unit",
        accessor: "unit"
    },

    {
        header: "Frequency",
        accessor: "frequency"
    },
    {
        header: "Days",
        accessor: "days"
    },
    {
        header: "Morning",
        accessor: "morning"
    },
    {
        header: "Noon",
        accessor: "noon"
    },
    {
        header: "Evening",
        accessor: "evening"
    },
    {
        header: "Night",
        accessor: "night"
    },
    {
        header: "Date",
        accessor: "createdAt"
    }

]

const PAST_MEDICINE_HISTORY_HEADER = [
    {
        header: "Date",
        accessor: "createdAt"
    },

    {
        header: "Medicine",
        accessor: (row) => row.medicine_name
    }
]


const initialOPDBillingDataObj = {
    data: [],
    loading: false
};


export const RegularReceiptVoucher = () => {
    const doctorIDRef = useRef();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const [detailList, setDetailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOPDBillingDataObj);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
    const [patientDetailList, setPatientDetailList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [complaints, setComplaints] = useState([])
    const [departmentDropdown, setDepartmentDropdown] = useState([]);
    const [medicineDetailList, setmedicineDetailList] = useState([]);
    const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
    const [addComplaintDialogueOpen, setAddComplaintDialogueOpen] = useState(false)
    const [addDiagnosDialogOpen, setAddDiagnosDialogOpen] = useState(false);
    const [diagnos, setDiagnos] = useState([])
    const [addMedicineDialogue, setAddMedicineDialogue] = useState(false);
    const [patientVitals, setPatientVitals] = useState([]);
    const [input, setInput] = useState('')
    const [originalData, setOriginalData] = useState([])
    const [isFiltered, setIsFiltered] = useState(false)
    const [pastComplaints, setPastComplaints] = useState([])
    const [pastDiagnos, setPastDiagnos] = useState([])
    const [pastService, setPastService] = useState([])
    const [pastMedicine, setPastMedicine] = useState([])


    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        const dayDifference = today.getDate() - birthDate.getDate();
        if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
            age--;
        }
        return age;
    }

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                uhid: Yup.string().required(' '),
            })
        ),
        defaultValues: {
            date: new Date().toISOString().split('T')[0],
            time: getCurrentDateTime('time'),
            bill: {
                out_sourced: 'No',
                rec_amt_1: 0,
                rec_amt_2: 0,
                tds_amt: 0,
                disc_amt: 0,
                gst_amt: 0,
                net_amt: 0
            }
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;

    const getDepartmentDropdown = useCallback(async () => {
        const data = await dropdownFetch('department');
        setDepartmentDropdown(data);
    }, []);

    useEffect(() => {
        getDepartmentDropdown();
    }, getDepartmentDropdown)

    useEffect(() => {
        let total_qty = 0;
        let total_amt = 0;
        let disc_amt = 0;
        let net_amt = 0;
        let gst_amt = 0;
        detailList.forEach((detail) => {
            total_qty += detail.quantity;
            total_amt += detail.amount;
            disc_amt += detail.disc_amt;
            gst_amt += detail.gst_amt;
            net_amt += detail.net_amt;
        });
        setValue('bill.total_qty', total_qty);
        setValue('bill.total_amt', total_amt);
        setValue('bill.disc_amt', disc_amt);
        setValue('bill.gst_amt', gst_amt);
        setValue('bill.net_amt', net_amt);
    }, [detailList, setValue]);

    const netAmtWatch = watch('bill.net_amt');
    const recAmt1Watch = watch('bill.rec_amt_1');
    const recAmt2Watch = watch('bill.rec_amt_2');
    useEffect(() => {
        const total_recpt = +recAmt1Watch + +recAmt2Watch;
        setValue('bill.total_recpt', total_recpt);
        setValue('bill.balance_amt', netAmtWatch - total_recpt);
    }, [netAmtWatch, recAmt1Watch, recAmt2Watch, setValue]);

    useEffect(() => {
        if (selectedRecord) {
            const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
                '__v',
                '_id',
                'createdAt',
                'status',
                'service_items',
                'uhid',
                'complaints',
                'diagnos',
                'medicine',
                'vital'
            ]);
            keyValuePair.forEach(({ key, value }) => setValue(key, value));
            setValue('uhid', selectedRecord.uhid);
            setDetailList(selectedRecord.service_items);
            setComplaints(selectedRecord.complaints)
            setDiagnos(selectedRecord.diagnos)
            setmedicineDetailList(selectedRecord.medicine)
            setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
            setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
            searchPatientHandler(selectedRecord.uhid);
            if (selectedRecord?.vital) {
                setValue('vital.bp_sys', selectedRecord?.vital.bp_sys)
                setValue('vital.diastol', selectedRecord?.vital.diastol)
                setValue('vital.abdomen', selectedRecord?.vital.abdomen)
                setValue('vital.pulse', selectedRecord?.vital.pulse)
                setValue('vital.dm', selectedRecord?.vital.dm)
                setValue('vital.ihd', selectedRecord?.vital.ihd)
                setValue('vital.con_level', selectedRecord?.vital.con_level)
                setValue('vital.temp', selectedRecord?.vital.temp)
                setValue('vital.weight', selectedRecord?.vital.weight)
                setValue('vital.resp_rate', selectedRecord?.vital.resp_rate)
                setValue('vital.chest', selectedRecord?.vital.chest)
                setValue('vital.cvs', selectedRecord?.vital.cvs)
                setValue('vital.dre', selectedRecord?.vital.dre)
                setValue('vital.cns', selectedRecord?.vital.cns)
                setValue('vital.any_other', selectedRecord?.vital.any_other)
                setValue('vital.allergies', selectedRecord?.vital.allergies)
                setValue('vital.height', selectedRecord?.vital.height)
                setValue('vital.blood_group', selectedRecord?.vital.blood_group)
                setValue('vital.pallor', selectedRecord?.vital.pallor)
                setValue('vital.cyanos', selectedRecord?.vital.cyanos)
                setValue('vital.jvp', selectedRecord?.vital.jvp)
                setValue('vital.lymphade', selectedRecord?.vital.lymphade)
                setValue('vital.hydration', selectedRecord?.vital.hydration)
                setValue('vital.asthma', selectedRecord?.vital?.asthma)
                setValue('vital.icterus', selectedRecord?.vital?.icterus)
                setValue('vital.clubbing', selectedRecord?.vital?.clubbing)
                setValue('follow_up_date', selectedRecord?.follow_up_date)
                setValue('follow_up_days', selectedRecord?.follow_up_days)
                setValue('advice', selectedRecord?.advice)
                setValue('remarks', selectedRecord?.remarks)
            }
        } else {
            reset();
        }
    }, [selectedRecord]);

    const formSubmit = async (formValues) => {
        setLoading(true);
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const response = await request(editFlag ? '/opd-requisition-edit' : '/opd-requisition-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: { ...formValues, service_items: detailList, complaints: complaints, medicine: medicineDetailList, diagnos: diagnos },
        });
        if (response?.success) {
            toast(`Successfully ${editFlag ? 'updated' : 'created'} OPD Requisition`, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
            reset();
        } else {
            toast(`Failed to ${editFlag ? 'update' : 'create'} OPD Requisition`, {
                variant: 'error'
            });
        }
        setLoading(false);
    };


    const handleRowDelete = (rowId) => {
        setDetailList((prev) => prev.filter((data) => {
            return data.service !== rowId;
        }));
    };

    const handleComplaintDelete = (rowId) => {
        setComplaints((prev) => prev.filter((data) => {
            return data.complaints != rowId
        }))
    }


    const handleDiagnosDelete = (rowId) => {
        setDiagnos((prev) => prev.filter((data) => {
            return data.add_diagnos != rowId
        }))
    }

    const handleDeleteMedicine = (rowId) => {
        setmedicineDetailList((prev) => prev.filter((data) => {
            return data.medicine_name != rowId
        }))
    }


    const onDetailAddHandler = (data) => {
        if (detailList.some((detail) => detail.service === data.service)) {
            toast('Same service already taken.', { variant: 'error' });
        } else {
            setDetailList((prev) => [...prev, { ...data }]);
        }
    };

    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/opd-requisition-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted OPD Requisition', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to delete OPD Requisition', { variant: 'error' });
        }
        setLoading(false);
    };


    const handleCancelRecord = async () => {
        setLoading(true);
        const response = await request('/opd-requisition-cancel', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully cancel OPD Requisition', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to cancel OPD Requisition', { variant: 'error' });
        }
        setLoading(false);
    };


    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setOpdBillingDataObj({ loading: true });
        const response = await request('/opd-requisition-list', { method: 'GET' });
        if (response.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const filteredData = sortedData.filter(item =>
                item.status === 'active' || item.status === 'inactive' || item.status === 'default'
            );
            setOpdBillingDataObj({ loading: false, data: filteredData });
            setOriginalData(filteredData)
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setOpdBillingDataObj({ loading: false });
        }
    };

    const searchPatientHandler = async (uhid = null) => {
        if (typeof uhid !== 'number' && typeof uhid !== 'string') uhid = null;
        setLoading(true);
        const today = new Date().toISOString().split('T')[0];
        if (!uhid) setSearchPatientRegisterationDialog(true);
        const response = await request('/patient-registeration-searchdetail', {
            method: 'GET',
            query: { uhid }
        });
        if (response?.success) {
            if (uhid) {
                const {
                    data: [patientData],
                } = response;
                setValue('visit', patientData.visit_no);
                setValue('op', patientData.op_no);
                setValue('patient_name', `${patientData.first_name} ${patientData.last_name}`);
                setValue('patient_suffix', patientData.name_suffix);
                setValue('opd_type', patientData.opd_type?.type);
                setValue('ref_type', patientData.ref_by?.referral_name);
                setValue('application_no', patientData.app_no_date);
                setValue('doctor', patientData.consultant?.name);
                doctorIDRef.current = patientData.consultant?._id;
                setValue('department', patientData.department?.department);
                setValue('patient_age', calculateAge(patientData?.dob));
                setValue('sponsor', patientData.sponsor?.name);
                setValue('remarks', patientData.remarks);
                setValue('queue_no', patientData.app_no_date);
                setValue('card_no', patientData.chq_card_no);
                setValue('vertical', patientData.vertical?.verticalname);
            } else {
                const todayData = response.data.filter(patient =>
                    new Date(patient.createdAt).toISOString().split('T')[0] === today
                );
                setPatientDetailList(todayData);
            }
        } else {
            toast('Failed to load patient details', { variant: 'error' });
        }
        setLoading(false);
    };


    const handleActiveTab = (newTabIndex) => {
        setActiveTab(newTabIndex);
    };

    useEffect(() => {
        if (opdBillingDataObj.data && opdBillingDataObj.data.length > 0) {
            setOriginalData(opdBillingDataObj.data);
            setIsFiltered(false);
        }
    }, [opdBillingDataObj.data]);

    const handleUhidSearch = () => {
        const lowercasedInput = input.toLowerCase();
        console.log("HELLO BILLING DATA OBJ", opdBillingDataObj)
        const filtered = opdBillingDataObj.data.filter((item) =>
            item?.uhid?.toString().toLowerCase().includes(lowercasedInput) ||
            item?.patient?.name?.toLowerCase().includes(lowercasedInput) ||
            item?.patient?.mobile_no?.toLowerCase().includes(lowercasedInput)
        );
        setOriginalData(filtered);
    };


    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handleUhidSearch();
    };


    return (
        <>
            <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
                <Container
                    sx={{
                        mt: 2,
                        p: 0.2,
                        border: '1px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',

                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                pb: 0.5,
                                mb: 3,
                                borderBottom: '1px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                                Regular Receipt Voucher
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        setDetailList([])
                                        reset()
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    variant="contained"
                                    onClick={() => window.open(`/print${pathname}/ProgressReport?refId=${selectedRecord._id}`, '_blank')}
                                >
                                    Progress Report
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Print`}
                                    variant="contained"
                                    onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                                    disabled={!selectedRecord || currentAction}
                                >
                                    Print
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                        handleCancelRecord();
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    onClick={handleQueryWindow}
                                    disabled={['new', 'edit'].includes(currentAction)}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained">Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Grid container spacing={2}>
                            <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>



                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Voucher Type</Typography>
                                    <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.8 }} placeholder="" name="voucher_type" />

                                </Stack>

                            </Grid>
                            <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>

                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Bank/Cash</Typography>
                                    <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.8 }} placeholder="" name="bankl_cash" />

                                </Stack>
                            </Grid>

                            <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                                <Stack spacing={0.5} direction="row" alignItems="center">

                                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Voucher No./ Date</Typography>
                                    <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="voucher_number" />
                                    <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="voucher_date" type="date" />

                                </Stack>

                            </Grid>
                            <Box marginLeft={'17px'} marginTop={'10px'}>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.5, fontWeight: 600, fontSize: '1.4rem' }}>Narration</Typography>
                                    <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px', } }} disabled={true} sx={{ flex: 0.8, }} placeholder="" name="narration" />
                                </Stack>
                            </Box>
                            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>



                                <Grid xs={10}>

                                    <Table
                                        containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                                        data={pastComplaints?.complaints || []}
                                        columns={ADD_Diagnosis}
                                        size="small"
                                        onDeleteHandler={handleRowDelete}
                                    />
                                </Grid>
                                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Account No.</Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="account_number" />

                                    </Stack>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Cheque Book No.</Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="cheque_book_number" />

                                    </Stack>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Cheque No.</Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="cheque-number" />

                                    </Stack>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Cheque Date</Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} type='date' disabled={true} sx={{ flex: 0.4 }} placeholder="" name="cheque_date" />

                                    </Stack>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Cheque Status</Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="cheque_status" />

                                    </Stack>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Amount</Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="amount" />

                                    </Stack>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Charges </Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="charges" />

                                    </Stack>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Total Debit</Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="total_debit" />

                                    </Stack>
                                    <Stack spacing={0.5} direction="row" alignItems="center">
                                        <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Total Credit</Typography>
                                        <TextField inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }} disabled={true} sx={{ flex: 0.4 }} placeholder="" name="total_credit" />

                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Container>
            </Paper >
            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        OPD Requisition Query Window
                    </Typography>

                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
                    <MuiTextField
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                                fontSize: '1.4rem' // Adjust input font size
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 1.4rem'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1.2rem' // Adjust label font size
                            }
                        }}
                        label="Search Patient"
                        variant="outlined"
                        value={input}
                        onChange={handleChange}
                    />
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={TABLE_HEADER}
                    data={originalData || []}
                    loading={opdBillingDataObj.loading}
                    onRowClick={(row) => {
                        delete row.patient;
                        setSelectedRecord(row);
                        setOpenQueryDialog(false);
                    }}
                />
            </Dialog>
            <Dialog
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                open={searchPatientRegisterationDialog}
                onClose={() => setSearchPatientRegisterationDialog(false)}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={1.5}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >

                    <Typography variant="h4" fontWeight="bold">
                        Patient Query Window
                    </Typography>
                    <IconButton onClick={() => setSearchPatientRegisterationDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Table
                    sx={{ mt: 3 }}
                    columns={PATIENT_TABLE_HEADER}
                    data={patientDetailList || []}
                    onRowClick={(row) => {
                        setValue('uhid', row.uhid);
                        setValue('visit', row.visit_no);
                        setValue('op', row.op_no);
                        setValue('patient_name', `${row.first_name} ${row.last_name}`);
                        setValue('patient_suffix', row.name_suffix);
                        setValue('opd_type', row.opd_type?.type);
                        setValue('ref_type', row.ref_by?.referral_name);
                        setValue('application_no', row.app_no_date);
                        setValue('doctor', row.consultant?.name);
                        doctorIDRef.current = row.consultant?._id;
                        setValue('department', row.department?.department);
                        setValue('sponsor', row.sponsor?.name);
                        setValue('remarks', row.remarks);
                        setValue('queue_no', row.app_no_date);
                        setValue('card_no', row.chq_card_no);
                        setValue('vertical', row.vertical?.verticalname);
                        setValue('patient_age', calculateAge(row.dob));
                        setValue('mobile', row?.address?.mobile);
                        setSearchPatientRegisterationDialog(false);
                        setPatientVitals(row || {})
                        setPastComplaints(row || {})
                        setPastDiagnos(row || {})
                        setPastService(row || {})
                        setPastMedicine(row || {})
                        console.log("HELLO PATIENT VITALS", patientVitals)
                    }}
                />
            </Dialog>
            <Dialog
                open={addMedicineDialogue}
                onClose={() => setAddMedicineDialogue(false)}
                PaperProps={{ sx: { p: 2, width: '35rem' } }}
                maxWidth="xl"
                scroll="body"
            >
                <DischargeSummaryMedicineDetailsForm
                    onClose={() => setAddMedicineDialogue(false)}
                    onAdd={(row) => {
                        if (medicineDetailList.some((medicine) => medicine.medicine_name === row.medicine_name)) {
                            toast('Medicine  already taken', { variant: 'error' });
                        } else {
                            setmedicineDetailList((prev) => [...prev, row]);
                            console.log("HELLO DETAILS", medicineDetailList)
                        }
                    }}
                />
            </Dialog>

            <Dialog
                open={addDiagnosDialogOpen}
                onClose={() => setAddDiagnosDialogOpen(false)}
                PaperProps={{ sx: { p: 2, width: '35rem' } }}
                maxWidth="xl"
                scroll="body"
            >
                <DischargeSummaryAddDiagnosForm
                    onClose={() => setAddDiagnosDialogOpen(false)}
                    onAdd={(row) => {
                        if (diagnos.some((diagnos) => diagnos.add_diagnos === row.add_diagnos)) {
                            toast('Diagnos already taken', { variant: 'error' });
                        } else {
                            setDiagnos((prev) => [...prev, row]);
                        }
                    }}
                />
            </Dialog>
            <Dialog
                open={addDetailsDialogOpen}
                onClose={() => setAddDetailsDialogOpen(false)}
                PaperProps={{ sx: { width: '80%', height: '90vh', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <OPDBillingDetailForm
                    doctorID={doctorIDRef.current}
                    onClose={() => setAddDetailsDialogOpen(false)}
                    onAdd={onDetailAddHandler}
                />
            </Dialog>
        </>
    );
};
